import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'
import React from 'react'
import { dispatch } from '../../jsCore/application/appStore'
import { zommdImpression } from '../../jsCore/organizedByType/actions/analyticsActions'

function getScriptName() {
  return externalScriptsConfig.zoomd.name
}

function addStyle(searchDiv) {
  searchDiv.setAttribute('zoomdSearch', '{"trigger":"OnClick"}')
}

function setupReportAnalytics() {
  let searchWraaperDiv = document.querySelector('.search-comp-zoomd')
  if (searchWraaperDiv !== undefined) {
    searchWraaperDiv.addEventListener('click', function() {
      dispatch(zommdImpression())
    })
  }
}
function initZoomd() {
  let searchDiv = document.querySelector('.search-comp-zoomd')
  if (searchDiv !== undefined && searchDiv !== null) {
    setupReportAnalytics()
    addStyle(searchDiv)
    externalScriptLoader.load({
      name: getScriptName(),
      loadNow: true,
    })
  }
}

export function injectSearch() {
  initZoomd()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/search/searchInjector.js